import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  root: {
    flexDirection: 'column',
    paddingRight: 20,
  },
  header: {
    flexDirection: 'row',
  },
  headerContent: {
    flex: 1,
    flexDirection: 'column',
  },
  arrowWrapper: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  arrow: {
    marginTop: 15,
  },
});

export const arrowSVGStyles = {
  height: 7,
  width: 14,
  thickness: 1,
  color: PALETTE.secondaryText,
};
